import Layout from "../../components/layout";

const TermsOfUse = () => {
  return (
    <Layout>
      <div className="flex px-4 tablet:px-[8rem] bg-mistGray pt-[4rem] pb-[6rem] mt-[6rem]">
        <div className="flex flex-col gap-4 rounded-lg p-6 shadow-lg bg-white">
          <h2 className="font-bold">Go Vahan Terms of Use</h2>
          <strong>8- Terms &amp; Conditions</strong>

          <p>
            This is user agreement (or Terms of Service&quot;) for Go Vahan , an
            application owned and operated by Go Vahan carrier Pvt. Ltd.
          </p>
          <p>
            The Agreement, User Agreement or Terms of Service, individually and
            interchangeably refer to the updated/revised terms of service for Go
            vahan , as periodically revised/updated and made available on the Go
            Vahan platform.
          </p>
          <p>
            Go Vahan Platform would mean and refer to the application, that
            enables vehicles rental Services such as through a Mobile Apps,
            Websites and customer support systems.{" "}
          </p>
          <p>
            This Agreement, entered into between You and Go Vahan is a legally
            binding agreement made between you (&quot;You,&quot;
            &quot;Your,&quot; or &quot;Yourself&quot;) and Go Vahan . (&quot;Go
            Vahan,&quot;We,&quot; &quot;Us&quot; or &quot;Our&quot;). The
            Agreement refers to the collective terms set out in this part, Part
            A and Part B, herein under.
          </p>
          <p>
            We reserve the right to amend this Agreement from time to time and
            we shall post the updated terms on the Go Vahan Platform. When We
            post amended terms on the Go Vahan Platform, You agree that, You may
            not use the Services without accepting them. Except as stated below,
            all amended terms shall automatically be effective after they are
            posted on the Go Vahan Platform. Notwithstanding any headings,
            classifications, definitions, etc., Clauses 5-30 and such other
            clauses by their very nature shall apply to all Services provided on
            the Go Vahan Platform.
          </p>
          <p>
            Your use and access, to the Go Vahan Platform is licensed by Go
            Vahan only upon the condition that You accept all the terms
            contained in this Agreement. By signing up with or by using the Go
            Vahan Platform, You confirm that You understand this Agreement and
            accept all of its terms. Any use of the Go Vahan Platform without
            accepting the terms of the Agreement shall be deemed as illegal and
            unauthorised use of the Go Vahan Platform. If you don&#39;t choose
            to accept the terms , you should not signup on the platform.
          </p>
          <p>
            This paragraph applies to any version of the Go Vahan Platform that
            You acquire from the Google Play Store, Websites hosted by the
            company. Google Play store is not a party to this Agreement and
            shall have no obligations with respect to the Go Vahan Platform.{" "}
          </p>
          <p>
            Go Vahan,not Google, is solely responsible for the Go Vahan Platform
            and the content thereof as set forth hereunder. However, Google and
            Google&#39;s Play Store subsidiaries are third party beneficiaries
            of this Agreement. Upon Your acceptance of this Agreement, Google
            shall have the right (and will be deemed to have accepted the right)
            to enforce this Agreement against You as a third party beneficiary
            thereof. This Agreement incorporates by reference the Licensed
            Application End User Licence Agreement published by Google for
            purposes of which, You are &quot;the End-User.&quot; In the event of
            a conflict in the terms of the Licensed Application End User License
            Agreement and this Agreement, the terms of this Agreement shall
            apply.
          </p>
          <strong>1.TERMINATION</strong>

          <p>
            1.1 - We may terminate or suspend the access to our Go Vahan and/or
            Go Vahan Platform at any point in time without cause and without
            prior notice or liability, including without limitation any breach
            of these Terms.
          </p>
          <p>
            1.2 - You are entitled to terminate the agreement, after clearing
            any balance due, by closing of Your User Account. Go Vahan reserves
            the right to keep the data of Your User Account for a period as may
            be required by Go Vahan .
          </p>
          <strong>2. Rights and ownership</strong>
          <p>
            2.1 - Go Vahan shall own all right, title and interest, including
            all related intellectual property rights, in and to (i) the Go Vahan
            Platform, Application, product, Go Vahan Services and any
            suggestions, ideas, enhancement requests,
            feedback,data,recommendations or any other offering; (ii) text,
            graphics, user interfaces, visual interfaces, photographs,
            trademarks, logos, sounds, music, artwork and computer code; or
            (iii) other information provided by You or any other party relating
            to the Go Vahan Platform, Application or the Go Vahan Taxi Service.
            Third party trademarks may appear on this Go Vahan Platform/
            Application and all rights therein are reserved to the registered
            owners of those trademarks.
          </p>
          <strong>3.LIMITED LICENSE</strong>
          <p>
            3.1 - Subject to Your compliance with these Terms,Go Vahan grants
            You a limited, revocable, non-exclusive, non- transferable and
            non-sublicensable license to download and install a copy of the
            Application on a single mobile device that You own or control and to
            run such copy of the Application solely for Your own personal use
            and to use the Go Vahan Platform.
          </p>
          <p>
            3.2 - You shall not (i) license, sublicense, sell, resell, transfer,
            assign, distribute or otherwise commercially exploit or make
            available to any third party, Go Vahan Platform in any way; (ii)
            modify or make derivative works based upon the Service or
            Application; (iii) create Internet “links” to the Go Vahan Service
            or “frame” or “mirror” any Go Vahan Platform on any other server or
            wireless or Internet-based device; (iv) reverse engineer or access
            the Go Vahan Platform in order to (a) design or build a competitive
            product or service, (b) design or build a product using similar
            ideas, features, functions or graphics of the Service or Go Vahan
            Platform, or (c) copy, reproduce, record, or make available to the
            public any ideas, features, functions or graphics of Go Vahan
            Platform, or (v) launch an automated program or script, including,
            but not limited to, web spiders, web crawlers, web robots, web ants,
            web indexers, bots, viruses or worms, or any program which may make
            multiple server requests per second, or unduly burdens or hinders
            the operation and/or performance of Go Vahan Platform.{" "}
          </p>
          <strong>3.3 You shall not:</strong>
          <p>
            - (i) send spam or otherwise duplicative or unsolicited messages in
            violation of applicable laws; (ii) send or store infringing,
            obscene, threatening, libellous, or otherwise unlawful or tortious
            material, including material harmful to children or violative of
            third party privacy rights; (iii) send or store material containing
            software viruses, worms, Trojan horses or other harmful computer
            code, files, scripts, agents or programs; (iv) interfere with or
            disrupt the integrity or performance of the Go Vahan Platform, the
            Application or Go Vahan or the data contained therein; or (v)
            attempt to gain unauthorized access to the Go Vahan Platform, the
            Application or Go Vahan or its related systems or networks; or (vi)
            You shall not make copies of any data, information, pricing,
            features, codes, source codes, intellectual property, etc.{" "}
          </p>
          <p>
            3.4 - Go Vahan will have the right to investigate and prosecute
            violations of any of the above to the fullest extent of the Go Vahan
            may involve and cooperate with law enforcement authorities in
            prosecuting users who violate these Terms.{" "}
          </p>
          <p>
            3.5 - You acknowledge that Go Vahan has no obligation to monitor
            Your access to or use of the Go Vahan Platform,but has the right to
            do so for the purpose of operating the Go Vahan Platform , to ensure
            Your compliance with these Terms, or to comply with Applicable Law.{" "}
          </p>
          <p>
            3.6 - Go Vahan reserves the right, at any time and without prior
            notice, to remove or disable access to any account, any content that
            Go Vahan , at its sole discretion, considers to be in violation of
            these Terms or otherwise harmful to the Go Vahan Platform.
          </p>
          <strong>4.ELIGIBILITY</strong>
          <p>
            4.1 - Our Services are available only to, and may only be used by
            individuals who can form legally binding contracts under applicable
            law. Without limiting the foregoing, Our Services are not available
            to children (persons under the age of 18) or to temporarily or
            indefinitely terminated Participants, both directly or otherwise. By
            becoming a Participant, You represent and warrant that You are at
            least 18 years old. By using the Go Vahan Platform and/or the
            Services, You represent and warrant that You have the right,
            authority and capacity to enter into this Agreement and to abide by
            the terms and conditions of this Agreement.{" "}
          </p>
          <p>
            4.2 - You represent that You are the sole authorized user of Your
            account. You are responsible for maintaining the confidentiality of
            any password or OTP provided by You or Go Vahan for accessing the
            Services. You are solely and fully responsible for all activities
            that occur under account. Go Vahan has no control over the use of
            any User’s account and expressly disclaims any liability derived
            therefrom. Should You suspect that any unauthorized party may be
            using Your account or You suspect any other breach of security, You
            shall do all possible to secure and prevent further any such access
            and You will also contact Us immediately.
          </p>
          <strong>5. VERIFICATION OF IDS AND PHONE NUMBER</strong>

          <p>
            5.1 - By accepting the terms and conditions contained herein, every
            Member or any person who wishes to register as a Member hereby
            agrees and consents to the fact that Go Vahan collects and uses the
            profile information, IDs / documents belonging to them including but
            not limited to Driving License, Official Email Id, PAN Card and
            AADHAR card or other relevant proof-of-identity documents - for the
            purpose of verification of the information contained in such IDs /
            documents by third party service providers.{" "}
          </p>
          <strong>6. SOCIAL MEDIA AND NETWORKING SITES</strong>
          <p>
            6.1 - As part of the functionality of the Go Vahan Platform, You may
            be able to login through online accounts You may have with third
            party service providers (each such account, a “Third Party Account”)
            by either:
          </p>
          <p>
            6.2 - Providing Your Third Party Account login information through
            the RodBez Platform; or
          </p>
          <p>
            6.3 - Allowing Go Vahan to access Your Third Party Account, as is
            permitted under the applicable terms and conditions that govern Your
            use of each Third Party Account.
          </p>
          <p>
            6.4 - You represent that You are entitled to disclose Your Third
            Party Account login information to Go Vahan and/or grantGo Vahan
            access to Your Third Party Account (including, but not limited to,
            for use for the purposes described herein), without breach by You of
            any of the terms and conditions that govern Your use of the
            applicable Third Party Account and without obligating Go Vahan to
            pay any fees or making Go Vahan subject to any usage limitations
            imposed by such third party service providers.
          </p>
          <p>
            6.5 - By granting Go Vahan access to any Third Party Accounts, You
            understand that-{" "}
          </p>
          <p>
            - Go Vahan may access, make available and store (if applicable) any
            content that You have provided to and stored in Your Third Party
            Account (the “SNS Content”) so that it is available on and through
            the Go Vahan Platform via Your account, including without limitation
            any demographic, image, friend, contacts or following/followed
            lists, and -Go Vahan may submit and receive additional information
            to Your Third Party Account as indicated herein.{" "}
          </p>
          <p>
            -Unless otherwise specified in this Agreement, all SNS Content, if
            any, shall be considered to be Your Information (as defined below)
            and Your Content for purposes of this Agreement.
          </p>
          <p>
            -Depending on the Third Party Accounts You choose and subject to the
            privacy settings that You have set in such Third Party Accounts,
            personally identifiable information that You post to Your Third
            Party Accounts may be available on and through the Go Vahan
            Platform.
          </p>
          <p>
            6.6 - Please note that if a Third Party Account or associated
            service becomes unavailable or the Go Vahan Platform’s access to
            such Third Party Account is terminated by the third party service
            provider, then SNS Content may no longer be available on and through
            the Go Vahan Platform.
          </p>
          <p>
            6.7 - Please note that your relationship WITH the third party
            service providers associated with your third party accounts is
            governed solely by your agreement(s) with such THIRD party service
            providers. Go Vahan makes no effort to review any SNS Content for
            any purpose, including but not limited to, for accuracy, legality or
            non-infringement, and Go Vahan is not responsible for any SNS
            Content.
          </p>
        </div>
      </div>
    </Layout>
  );
};
export default TermsOfUse;
